import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;
`;

export const Header = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    color: #333;
    margin: 0;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Progress = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  h2 {
    font-size: 1.25rem;
    color: #333;
    margin-bottom: 16px;
  }

  .progress-bar {
    height: 8px;
    background: #eee;
    border-radius: 4px;
    margin-bottom: 12px;
    overflow: hidden;

    .fill {
      height: 100%;
      width: ${props => props.progress}%;
      background: #34574A;
      transition: width 0.3s ease;
    }
  }

  .steps-completed {
    font-size: 0.875rem;
    color: #666;
  }
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Step = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  text-align: left;

  ${props => props.active && `
    background: #34574A;
    color: white;
  `}

  ${props => props.completed && `
    background: #e6f4ea;
    color: #1e7e34;
  `}

  .number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${props => props.active ? 'rgba(255, 255, 255, 0.2)' : props.completed ? '#1e7e34' : '#eee'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
  }

  .text {
    font-size: 0.875rem;
    font-weight: 500;
  }

  &:hover {
    transform: translateY(-2px);
  }
`;

export const FormContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

export const FormSection = styled.div`
  padding: 24px;

  h2 {
    font-size: 1.25rem;
    color: #333;
    margin: 0 0 24px 0;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div`
  &.full-width {
    grid-column: 1 / -1;
  }

  label {
    display: block;
    font-size: 0.875rem;
    color: #666;
    margin-bottom: 8px;
  }

  input, select, textarea {
    width: 100%;
    padding: 12px;
    border: 2px solid #eee;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #34574A;
      outline: none;
    }
  }

  textarea {
    min-height: 120px;
    resize: vertical;
  }

  .hint {
    font-size: 0.75rem;
    color: #666;
    margin-top: 4px;
  }
`;

export const ImageUpload = styled.div`
  border: 2px dashed #eee;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #34574A;
  }

  input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  .icon {
    font-size: 2rem;
    color: #666;
    margin-bottom: 8px;
  }

  .text {
    font-size: 0.875rem;
    color: #666;
  }

  .preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .remove {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    z-index: 1;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  border-top: 1px solid #eee;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &.primary {
    background: #34574A;
    color: white;
    border: none;

    &:hover {
      background: #2a4539;
    }
  }

  &.secondary {
    background: white;
    border: 2px solid #eee;
    color: #666;

    &:hover {
      background: #f8f9fa;
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Preview = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-top: 24px;
`;

export const PreviewHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #eee;

  h2 {
    font-size: 1.25rem;
    color: #333;
    margin: 0;
  }
`;

export const PreviewContent = styled.div`
  padding: 24px;
`;